import React, { useContext } from 'react';
import styles from './LogosScroll.module.css';
import { ThemeContext } from '../../../context/ThemeContext';
import logosDark from '../../../assets/images/logos-dark.png';
import logosLight from '../../../assets/images/logos-light.png';

const LogosScroll: React.FC = () => {
    const context = useContext(ThemeContext);

    if (!context) {
        throw new Error("LogosScroll must be used within a ThemeProvider");
    }

    const { theme } = context;
    const logos = theme === "dark" ? logosDark : logosLight;

    return (
        <div className={styles.logosContainer}>
            <div className={styles.logosTrack}>
                <div className={styles.logosContent}>
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                    <img src={logos} alt="Client logos" className={styles.logos} />
                </div>
            </div>
        </div>
    );
};

export default LogosScroll; 